"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentationApiKey = exports.V1FactoryKey = exports.V1ServerToServer = exports.ServerToServer = exports.SvixWebhook = exports.V1ApplePassService = exports.ApplePassService = exports.V1DeviceCertificate = exports.DeviceCertificate = exports.V1FleetSat = exports.FleetSat = exports.v1Roles = exports.roles = exports.V1RoleBased = exports.RoleBased = exports.RoleRequirement = exports.AdminOrDealerUser = exports.DealerUser = exports.SystemAdmin = exports.AdminUser = exports.Requirement = exports.GuardRoles = exports.hasOptionalUser = exports.OptionalUser = exports.SessionUser = exports.V1AuthenticatedUser = exports.AuthenticatedUser = exports.unguarded = exports.isPublic = exports.Public = exports.PublicRoute = exports.Scheme = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const User = __importStar(require("../../user"));
const Authorization = __importStar(require("../v2/spec/authorization"));
const Error = __importStar(require("../v2/spec/error"));
const Annotations = __importStar(require("./annotations"));
const Compose = __importStar(require("./compose"));
const ApiError = __importStar(require("./error"));
const Order = __importStar(require("./order"));
exports.NAMESPACE = 'Culligan.Api.OpenApi.Security';
/*
 * Every middleware below is documentation-only: it mirrors one of the route
 * guards in `unified-api/src/libraries/routing/guards` so that the generated
 * OpenAPI document exposes the same security requirements the Express handlers
 * enforce. None of them needs a `Layer` implementation because the specs that
 * use them are only ever converted to OpenAPI, never served.
 *
 * Security scheme *names* (the keys of the `security` records) are shared on
 * purpose: `OpenApi.fromApi` emits one `components.securitySchemes` entry per
 * name, so reusing `bearer` everywhere yields a single bearer component.
 *
 * `fromApi` keeps the *first* definition it meets for a name and drops the
 * rest, and groups are visited in identifier order, so two definitions of the
 * same name would make the shipped description depend on group naming. Hence
 * every scheme shared with the served v2 middleware (`bearer`, `cPortToken`,
 * `sat`) is the very object `UserAuthorization` declares, never a copy.
 */
/** Legacy guards answer 401 when the caller is not authenticated at all. */
const NotAuthenticated = Error.NotAuthenticatedErrorFromProtocol;
/** ... and 403 when the caller is authenticated but lacks the required role. */
const AuthenticatedButForbidden = effect_1.Schema.Union(Error.NotAuthenticatedErrorFromProtocol, Error.ForbiddenErrorFromProtocol);
/**
 * Same statuses as {@link AuthenticatedButForbidden}, in the v1 wire format
 * (`{ message }` only). v1 Express guards never set `error.type`.
 */
const V1AuthenticatedButForbidden = effect_1.Schema.Union(ApiError.V1NotAuthenticated, ApiError.V1Forbidden);
/** The one definition of each user-credential scheme; see the note above. */
exports.Scheme = Authorization.UserAuthorization.security;
const { bearer, cPortToken, sat } = exports.Scheme;
/**
 * Marks an endpoint or group as deliberately public.
 *
 * An endpoint without any security middleware publishes with no security
 * requirement, exactly like a public one. This annotation is what tells the
 * two apart, so a forgotten guard mirror can be detected ({@link unguarded})
 * instead of shipping a protected route documented as open.
 */
class PublicRoute extends effect_1.Context.Tag(`${exports.NAMESPACE}.PublicRoute`)() {
}
exports.PublicRoute = PublicRoute;
/**
 * `PublicRouteGuard`: no security requirement.
 *
 * Applies {@link PublicRoute}; nothing else is attached. Apply to a group
 * when every endpoint of the legacy router is public, otherwise per endpoint.
 */
const Public = (target) => target.annotate(PublicRoute, true);
exports.Public = Public;
const isPublic = (target) => effect_1.Context.getOption(target.annotations, PublicRoute).pipe(effect_1.Option.isSome);
exports.isPublic = isPublic;
const hasSecurity = (middlewares) => Array.from(middlewares).some(platform_1.HttpApiMiddleware.isSecurity);
/**
 * `METHOD /path` of every endpoint that is neither guarded nor {@link Public}.
 *
 * Every endpoint is examined individually. It counts as guarded when a
 * middleware with a `security` record is attached to it or to its group;
 * plain middlewares (tracing, tenant, rate limit) do not count.
 *
 * Middleware attached to the API itself is deliberately ignored, even when it
 * carries security. `OpenApi.fromApi` writes API-level security into the
 * document-level `security` field and emits `security: []` on every
 * operation, and an empty operation-level array removes the document-level
 * requirement in OpenAPI, so readers and generated clients treat each
 * operation as unauthenticated. Counting it here would report a root as
 * covered while its document says the opposite. Declare guards per group or
 * per endpoint, which is also how the legacy Express guards are attached.
 *
 * `Generate.toOpenApi` rejects a root for which this is not empty.
 */
const unguarded = (api) => Order.sorted(Compose.endpoints(api)
    .filter(([group, endpoint]) => !guards(group) && !guards(endpoint))
    .map(([, endpoint]) => `${endpoint.method} ${endpoint.path}`));
exports.unguarded = unguarded;
/** Whether a target carries a guard of its own, either a mirror or {@link Public}. */
const guards = (target) => (0, exports.isPublic)(target) || hasSecurity(target.middlewares);
/**
 * `AuthenticatedUserRouteGuard`: any authenticated user via SSO bearer or CPort.
 *
 * Not an alias of `UserAuthorization`: the served v2 middleware also accepts
 * a `?sat=` credential, whereas the legacy guard only admits `SSOSession` and
 * `CPortSession` (`ALLOWED_SESSION_TYPES`) and the session factory does not
 * build a session from `sat` at all. SAT-guarded legacy routes use
 * {@link FleetSat}.
 */
class AuthenticatedUser extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.AuthenticatedUser`, {
    failure: NotAuthenticated,
    security: { bearer, cPortToken },
}) {
}
exports.AuthenticatedUser = AuthenticatedUser;
/** v1 `AuthenticatedUserRouteGuard`: 401 and 403, body `{ message }` without `error.type`. */
class V1AuthenticatedUser extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.V1AuthenticatedUser`, {
    failure: V1AuthenticatedButForbidden,
    security: { bearer, cPortToken },
}) {
}
exports.V1AuthenticatedUser = V1AuthenticatedUser;
/**
 * The user-credential schemes without any failure: the carrier for
 * {@link OptionalUser}. Not a guard mirror; do not apply it directly.
 */
class SessionUser extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.SessionUser`, {
    security: { bearer, cPortToken },
}) {
}
exports.SessionUser = SessionUser;
/**
 * `PublicRouteGuard` in front of a controller that still reads the session
 * user (`session.getUser()`): no guard enforces a credential, yet the route
 * cannot succeed without one.
 *
 * Publishes `bearer` and `cPortToken` as *optional* requirements (the empty
 * requirement first), so Swagger UI and generated clients offer the token
 * while the document still says the router does not demand it. Without a
 * credential the controller fails on its own terms, which each endpoint
 * description states; the middleware therefore adds no 401 of its own.
 */
const OptionalUser = (endpoint) => endpoint.middleware(SessionUser).annotate(platform_1.OpenApi.Override, {
    security: [{}, { bearer: [] }, { cPortToken: [] }],
});
exports.OptionalUser = OptionalUser;
/** Whether an endpoint was declared with {@link OptionalUser}. */
const hasOptionalUser = (endpoint) => Array.from(endpoint.middlewares).some(middleware => middleware.key === SessionUser.key);
exports.hasOptionalUser = hasOptionalUser;
/*
 * Permission levels share the `bearer` scheme with `AuthenticatedUser`, and
 * `OpenApi.fromApi` keeps the first definition of a scheme name. The role a
 * level requires therefore cannot live on the scheme; it is exposed through
 * {@link Requirement} so ticket modules can put it in the group description.
 * The scheme text itself is also shipped by the served v2 document, whose
 * operations state no role requirement, so it must not mention roles at all.
 */
const Role = User.GlobalUserRole.enums;
/**
 * Roles each permission level accepts, as the legacy guards evaluate them:
 * `BaseSession.isSysAdmin` / `isAdmin` / `isDealer` over the lists in
 * `unified-api/src/libraries/auth/userroles.js`.
 *
 * Deliberately *not* derived from `User.DataManagementUserRole`: that enum
 * includes `brandTechOperator`, which `getDataManagementRoles()` excludes, so
 * the two disagree exactly where the document must match the guard. The
 * unified-api test `tests/libraries/routing/guards/guardroles.test.js` pins
 * these lists to the runtime ones so they cannot drift apart silently.
 */
exports.GuardRoles = {
    /** `getSystemRoles()` */
    SystemAdmin: [Role.SystemAdmin],
    /** `getSystemRoles()` ∪ `getDataManagementRoles()` (`AdminUserRouteGuard` checks both). */
    AdminUser: [
        Role.SystemAdmin,
        Role.Admin,
        Role.BrandManager,
        Role.BrandSupportOperator,
        Role.ClientAppAdmin,
    ],
    /** `getDealerRoles()` */
    DealerUser: [Role.Dealer, Role.DealerTechnician],
};
/** `a, b or c` */
const enumerate = (roles) => roles.length === 1
    ? roles[0]
    : `${roles.slice(0, -1).join(', ')} or ${roles.at(-1)}`;
/** Human readable role requirement of each permission level, derived from {@link GuardRoles}. */
exports.Requirement = {
    AdminUser: `Requires a data-management role (${enumerate(exports.GuardRoles.AdminUser)}).`,
    SystemAdmin: `Requires the ${enumerate(exports.GuardRoles.SystemAdmin)} role.`,
    DealerUser: `Requires a dealer role (${enumerate(exports.GuardRoles.DealerUser)}).`,
    AdminOrDealerUser: 'Requires a data-management or a dealer role ' +
        `(${enumerate([...exports.GuardRoles.AdminUser, ...exports.GuardRoles.DealerUser])}).`,
};
/** `AdminUserRouteGuard`: any role in `GuardRoles.AdminUser`. */
class AdminUser extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.AdminUser`, {
    failure: AuthenticatedButForbidden,
    security: { bearer, cPortToken },
}) {
}
exports.AdminUser = AdminUser;
/** `SysAdminUserRouteGuard`: the `sysAdmin` role only. */
class SystemAdmin extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.SystemAdmin`, {
    failure: AuthenticatedButForbidden,
    security: { bearer, cPortToken },
}) {
}
exports.SystemAdmin = SystemAdmin;
/** `DealerUserRouteGuard`: dealer roles (`dealer`, `dealerTechnician`). */
class DealerUser extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.DealerUser`, {
    failure: AuthenticatedButForbidden,
    security: { bearer, cPortToken },
}) {
}
exports.DealerUser = DealerUser;
/** `AdminOrDealerUserRouteGuard`: either a data-management or a dealer role. */
class AdminOrDealerUser extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.AdminOrDealerUser`, {
    failure: AuthenticatedButForbidden,
    security: { bearer, cPortToken },
}) {
}
exports.AdminOrDealerUser = AdminOrDealerUser;
/** Annotation listing the roles an `RBACRouteGuard`-protected endpoint accepts. */
class RoleRequirement extends effect_1.Context.Tag(`${exports.NAMESPACE}.RoleRequirement`)() {
}
exports.RoleRequirement = RoleRequirement;
/** `RBACRouteGuard` documented with the typed v2 error body (`error.type`). */
class RoleBased extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.RoleBased`, {
    failure: AuthenticatedButForbidden,
    security: { bearer, cPortToken },
}) {
}
exports.RoleBased = RoleBased;
/** v1 `RBACRouteGuard`. Failure is `{ success: false, error: { message } }`. */
class V1RoleBased extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.V1RoleBased`, {
    failure: V1AuthenticatedButForbidden,
    security: { bearer, cPortToken },
}) {
}
exports.V1RoleBased = V1RoleBased;
const describeRoles = (...allowed) => (endpoint) => {
    const sorted = Order.sorted(new Set(allowed));
    const secured = endpoint.annotate(RoleRequirement, sorted);
    return Annotations.appendDescription(`Allowed roles: ${sorted.join(', ')}.`)(secured);
};
/**
 * `RBACRouteGuard`: the caller must hold one of the listed roles.
 *
 * Returns an endpoint transformer: OpenAPI has no notion of roles for bearer
 * schemes, so the allowed roles are recorded as an annotation (for tooling)
 * and appended to the operation description (for readers).
 *
 * The failure body is the typed v2 protocol (`error.type`). v1 Express routes
 * use {@link v1Roles} instead.
 */
const roles = (...allowed) => (endpoint) => describeRoles(...allowed)(endpoint.middleware(RoleBased));
exports.roles = roles;
/** {@link roles} with the v1 protocol error body (`error.message`, no `error.type`). */
const v1Roles = (...allowed) => (endpoint) => describeRoles(...allowed)(endpoint.middleware(V1RoleBased));
exports.v1Roles = v1Roles;
/** `SatCredentialRouteGuard`: a fleet Service Access Token passed as `?sat=`. */
class FleetSat extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.FleetSat`, {
    failure: NotAuthenticated,
    security: { sat },
}) {
}
exports.FleetSat = FleetSat;
/**
 * `SatCredentialRouteGuard` as the Express routes answer it: 401 `INVALID_TOKEN`
 * only, body `{ message }` without `error.type`. The guard verifies that the
 * SAT exists; whether it grants the requested device is checked by the
 * controller, which answers its own 401.
 */
class V1FleetSat extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.V1FleetSat`, {
    failure: ApiError.V1NotAuthenticated,
    security: { sat },
}) {
}
exports.V1FleetSat = V1FleetSat;
/** `AuthenticatedDeviceRouteGuard`: device identified by its X.509 certificate + HMAC signature. */
exports.DeviceCertificate = Authorization.DeviceAuthorization;
/**
 * v1 body for `AuthenticatedDeviceRouteGuard`.
 *
 * The guard answers `{ message }` without `error.type`: 401 `INVALID_TOKEN` when the
 * caller is not authenticated, and 403 `NOT_ALLOWED` when the credentials are not a
 * device session. Legacy Express routes, including v2 routes such as the service menu,
 * use this body. {@link DeviceCertificate} stays the v2 401 used by served typed routes.
 * Both middlewares share the `certificate` scheme.
 */
class V1DeviceCertificate extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.V1DeviceCertificate`, {
    failure: V1AuthenticatedButForbidden,
    security: Authorization.DeviceAuthorization.security,
}) {
}
exports.V1DeviceCertificate = V1DeviceCertificate;
/** One shared object, so the v2 and v1 Apple middlewares never define the scheme twice. */
const applePassToken = platform_1.HttpApiSecurity.apiKey({ key: 'authorization' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Apple Wallet web service authentication: `Authorization: ApplePass <authenticationToken>`, ' +
    'where the token is the one embedded in the pass at generation time.'));
/**
 * `ApplePassServiceRouteGuard`: the Apple Wallet (PassKit) web service calling
 * back with `Authorization: ApplePass <authenticationToken>`.
 *
 * Effect has no generic `http` scheme, so like `cPortToken` this is modelled
 * as an API key in the `authorization` header. The guard answers 401 for a
 * missing/invalid token and 403 when the session is not a PassKit session.
 */
class ApplePassService extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.ApplePassService`, {
    failure: AuthenticatedButForbidden,
    security: { applePassToken },
}) {
}
exports.ApplePassService = ApplePassService;
/** v1 `ApplePassServiceRouteGuard`: 401 and 403, body `{ message }` without `error.type`. */
class V1ApplePassService extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.V1ApplePassService`, {
    failure: V1AuthenticatedButForbidden,
    security: { applePassToken },
}) {
}
exports.V1ApplePassService = V1ApplePassService;
/**
 * `WebHookRouteGuard`: Svix webhook signature.
 *
 * `SvixSession.verifyWebhook` rejects the call unless `svix-id`,
 * `svix-timestamp` and `svix-signature` are all present. A security
 * requirement can only name one of them without turning the three into
 * alternatives, so `svix-id` is the scheme (see `SvixAuthorization`) and the
 * other two are declared as required header parameters. An endpoint
 * transformer rather than a bare tag so both land together:
 * `endpoint.pipe(Security.SvixWebhook)`.
 */
const SvixWebhook = (endpoint) => Annotations.withRequestHeaders({
    'svix-timestamp': {
        description: 'Unix timestamp (seconds) at which Svix signed the delivery; part of the signed payload.',
    },
    'svix-signature': {
        description: 'Space separated list of `v1,<base64 HMAC-SHA256>` signatures over `{svix-id}.{svix-timestamp}.{body}`.',
    },
})(endpoint.middleware(Authorization.SvixAuthorization));
exports.SvixWebhook = SvixWebhook;
/*
 * The descriptions below ship in integrator-facing documents, so they describe
 * the mechanism and never name the server-side configuration holding the
 * secret (`API_STS_TOKEN`, `APIDOCS_*`); that is deployment detail.
 */
/** One shared object, so the v2 and v1 server-to-server middlewares never define the scheme twice. */
const stsKey = platform_1.HttpApiSecurity.apiKey({ key: 'key', in: 'query' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Shared server-to-server secret used by Pub/Sub push subscriptions and internal jobs; ' +
    'not available to end users or integrators.'));
/** Server-to-server / Pub/Sub push: `?key=` compared with the `API_STS_TOKEN` config value. */
class ServerToServer extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.ServerToServer`, {
    failure: NotAuthenticated,
    security: { stsKey },
}) {
}
exports.ServerToServer = ServerToServer;
/** v1 `QueryStringRouteGuard` (STS): 401 only, body `{ message }` without `error.type`. */
class V1ServerToServer extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.V1ServerToServer`, {
    failure: ApiError.V1NotAuthenticated,
    security: { stsKey },
}) {
}
exports.V1ServerToServer = V1ServerToServer;
/** One shared object, so every factory-key mirror declares the scheme once. */
const factoryKey = platform_1.HttpApiSecurity.apiKey({ key: 'key', in: 'query' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Shared secret of the device factory, issued to factory systems that provision devices; ' +
    'not available to end users or integrators.'));
/**
 * Device factory: `?key=` compared with the factory key (`QueryStringRouteGuard`).
 *
 * Its own scheme, never `stsKey`: the secret is a different one and the two
 * descriptions say so. The guard answers 401 only, in the v1 `{ message }` body.
 * Without a configured key the key itself never matches: the guard drops the
 * unset value.
 */
class V1FactoryKey extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.V1FactoryKey`, {
    failure: ApiError.V1NotAuthenticated,
    security: { factoryKey },
}) {
}
exports.V1FactoryKey = V1FactoryKey;
/**
 * Documentation routes: `?key=` compared with the key configured for the
 * requested document.
 *
 * Each version keeps its own set: v1 has user, admin and system keys
 * (`routes/v1/openapi/router.js`), v2 adds a fleet key
 * (`routes/v2/openapi/router.js`). The description therefore does not
 * enumerate them.
 */
class DocumentationApiKey extends platform_1.HttpApiMiddleware.Tag()(`${exports.NAMESPACE}.DocumentationApiKey`, {
    failure: NotAuthenticated,
    security: {
        docsKey: platform_1.HttpApiSecurity.apiKey({ key: 'key', in: 'query' }).pipe(platform_1.HttpApiSecurity.annotate(platform_1.OpenApi.Description, 'Access key for the requested documentation set; each document (user, admin, system, ...) ' +
            'is protected by its own key, obtained from the platform team.')),
    },
}) {
}
exports.DocumentationApiKey = DocumentationApiKey;
//# sourceMappingURL=security.js.map